import type { HeadingType } from "@silversea-ssc/ui-components-react";
import { Maybe } from "graphql/jsutils/Maybe";
import { BackgroundColor } from "types/componentBackground";
import { SanityBuilderSectionType } from ".";

export const hasContent = (
  sections: Maybe<Maybe<SanityBuilderSectionType>[]> | undefined
): sections is SanityBuilderSectionType[] => {
  if (!sections) return false;
  return sections.length > 0;
};

export class PageBuilderAutoHeading {
  private headingsUsed: HeadingType[] = [];

  constructor() {
    this.headingsUsed = [];
  }

  getSingleUseHeadingType(
    headingText: string | undefined,
    ...allowedHeadingTypes: HeadingType[]
  ): HeadingType {
    if ((headingText?.length || 0) === 0) return "None";

    const allowedNotUsed = allowedHeadingTypes.filter((x) =>
      this.headingsUsed.includes(x)
    );
    if (allowedNotUsed.length == 0) return "None";
    const toUse = allowedNotUsed[0];

    this.markHeadingUsed(toUse);
    return toUse;
  }

  markHeadingUsed(headingType: HeadingType): void {
    if (this.headingsUsed.includes(headingType)) return;
    this.headingsUsed.push(headingType);
  }
}

export type CardColor = "white" | "neutral05";
export const cardColorForBackground = (color: BackgroundColor): CardColor =>
  color == "white" ? "neutral05" : "white";
